import React from "react";
import { OPPORTUNITY_COLORS } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export const OpportunityBadge = ({ type, size = "sm" }) => {
  const { t } = useLang();
  const c = OPPORTUNITY_COLORS[type] || OPPORTUNITY_COLORS.LEARN;
  const pad = size === "md" ? "px-3 py-1 text-xs" : "px-2.5 py-0.5 text-xs";
  return (
    <span
      data-testid={`opportunity-badge-${type.toLowerCase()}`}
      className={`inline-flex items-center rounded-full font-sans font-semibold ${pad} border`}
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
    >
      {t(`opp.${type}`)}
    </span>
  );
};
